import { Form } from "antd";
import { useState } from "react";
import { requetsDeleteProviderSimulation, requetsProviderSimulation } from "../../../../redux/slices/simulation/simulationAction";
import { columnsProviderCalculation } from "../../../../types/columnsTables/columnProviderCalculation";
import { setSelectId, setSelectTypeForm } from "../../../../redux/slices/simulation/simulation";
import { typeForm } from "../../../../types/forms";

export const useColumnsProviderCalculation = (dispatch, updateProject) => {
    const [formProvider] = Form.useForm();
    const [editingKey, setEditingKey] = useState("");

    const onEditForm = async () => {
        try {
            setEditingKey("");
            const rowProvider = await formProvider.validateFields();
            let structureJson = {
                name: rowProvider.name,
                currency: rowProvider.currency,
                link: rowProvider.link,
                status: rowProvider.status,
                area: rowProvider.area,
                outsourceHours: rowProvider.outsourceHours,
                budget: rowProvider.budget,
            };
            dispatch(requetsProviderSimulation(structureJson, updateProject));
        } catch (error) {
            console.log("error");
        }
    };

    const activeEdit = (id) => {
        setEditingKey(id);
        dispatch(setSelectTypeForm(typeForm.edit));
        dispatch(setSelectId(id));
    };

    const editActive = (record) => {
        formProvider.setFieldsValue({
            name: record.name,
            currency: record.currency,
            link: record.link,
            status: record.status,
            area: record.area,
            outsourceHours: record.outsourceHours,
            budget: record.budget,
        });
        activeEdit(record.key);
    };

    //* column

    const { columns, props } = columnsProviderCalculation(
        {
            editAction: editActive,
            deleteAction: (form) => {
                dispatch(requetsDeleteProviderSimulation(form.key, updateProject));
            },
            isEditing: (record) => record.key === editingKey,
            cancelSave: () => {
                setEditingKey("");
            },
            editRow: onEditForm,
            cancelExpandle: () => {
                setEditingKey("");
            },
        },
        {
            editingKey: editingKey,
        }
    );
    return { columns, props, formProviderCalculation: formProvider };
};
